import React from 'react';
import Icon from '../../../components/AppIcon';

const EmptyState = ({ searchQuery }) => {
  return (
    <div className="flex flex-col items-center justify-center" style={{ padding: '48px 0', fontFamily: 'IBM Plex Sans, system-ui, sans-serif' }}>
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center" style={{ backgroundColor: '#2E2E2C', marginBottom: '24px' }}>
        <Icon name="FileText" size={32} color="#F5CB5C" />
      </div>
      <h3 className="text-lg md:text-lg font-semibold text-center" style={{ color: '#E8EDDF', marginBottom: '8px' }}>
        {searchQuery ? 'No posts found' : 'No published posts yet.'}
      </h3>
      <p className="text-sm md:text-base text-center max-w-md" style={{ color: '#CFDBD5' }}>
        {searchQuery
          ? `We couldn't find any posts matching "${searchQuery}". Try adjusting your search.`
          : 'Check back soon for new technical insights and articles.'}
      </p>
    </div>
  );
};

export default EmptyState;